export default "__VITE_ASSET__D4yDx5cD__"